import React from "react";
import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import RCPagination from "rc-pagination";

export const Pagination = styled(RCPagination).attrs({
  prevIcon: <i className="fa fa-caret-left" />,
  nextIcon: <i className="fa fa-caret-right" />
})`
  &.rc-pagination {
    display: flex;
  }

  li {
    display: inline-block;
  }

  .rc-pagination-item,
  .rc-pagination-jump-next,
  .rc-pagination-jump-prev,
  .rc-pagination-prev,
  .rc-pagination-next {
    font-size: 16px;
    padding: 15px 12px;
    cursor: pointer;
    color: ${colors.primary};

    a {
      color: ${colors.primary};
    }

    &-active a {
      font-style: italic;
      color: ${colors.goatGrey};
    }
  }

  .rc-pagination-jump-next,
  .rc-pagination-jump-prev {
    a:after {
      content: "...";
      display: inline-block;
      color: ${colors.goatGrey};
    }
  }

  .rc-pagination-disabled {
    cursor: not-allowed;
    color: ${colors.goatGrey};
  }
`;
